class FileProcessController {

    $onChanges(changes) {
        if (changes.file && this.file) {
            const file = this.file;
            const result = {
                name: file.name,
                size: file.size,
                type: file.type
            };

            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    result.preview = e.target.result;
                    this.onProcessed({ result: result });
                };
                reader.readAsDataURL(file);
            } else {
                this.onProcessed({ result: result });
            }
        }
    }
}

angular.module('cpm').component('fileProcess', {
    controller: FileProcessController,
    bindings: {
        file: '<',
        onProcessed: '&'
    }
});